<div class="order-deliveries">
  <div class="clearfix">
    <div class="clearfix">
      <h5 class="float-start mb-0">{{'project.order'|translate}} {{'ui.deliveries'|translate|lowercase}}</h5>
      <button type="button" class="btn btn-sm btn-link float-end p-0" (click)="toPlanning()">
        {{'ui.go-to'|translate }} {{'ui.the'|translate|lowercase}} {{'entity.planning'|translate}}
        <i class="fa fa-arrow-right"></i>
      </button>
    </div>
    <ul ngbNav #deliveryNav="ngbNav" [(activeId)]="activeTabId" class="nav nav-tabs mt-2">
      <li *ngFor="let tab of statusTabs" [ngbNavItem]="tab.id">
        <a ngbNavLink class="me-4" [ngClass]="tab.className" [class.active]="activeTabId === tab.id" (click)="selectTab(tab.id)">
          <div class="clearfix">
            <div *ngIf="tab.status !== null" class="float-start status-indicator mt-1 me-2" [ngClass]="tab.className"></div>
            <div class="float-start me-1">{{tab.label}}</div>
            <div class="float-start">({{tab.count}})</div>
          </div>
        </a>
      </li>
    </ul>
    <div class="delivery-tab-content">
      <ng-container
        *ngTemplateOutlet="deliveriesTable; context: {$implicit: activeItems, status: activeTab}">
      </ng-container>
    </div>
  </div>
</div>

<ng-template #deliveriesTable let-items let-status="status">
  <div *ngIf="items.length; else noDeliveries" class="table-responsive">
    <table class="table table-sm table-borderless">
      <thead>
        <tr>
          <td class="status ps-0"></td>
          <td class="time-column"><i class="far fa-clock"></i></td>
          <td>{{'project.order'|translate}} / {{'entity.project'|translate}}</td>
          <td>{{'company.plant'|translate}}</td>
          <td class="amount text-right">{{'order.delivered'|translate}}</td>
          <td class="remaining text-right">{{'entity.outstanding'|translate}}</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of items; trackBy: trackByOrderId" [class]="getStatusClass(item.status)">
          <td class="status ps-0">
            <span class="status-indicator" [ngClass]="getStatusClass(item.status)" [ngbTooltip]="getStatusLabel(item.status)"></span>
          </td>
          <td class="time">{{item.time}}</td>
          <td>
            <jbm-link-button [caption]="item.order.description"></jbm-link-button>
            <div class="">{{item.project.name}}</div>
          </td>
          <td>
            <span [ngbTooltip]="item.plant.name">{{item.plant.code}}</span>
          </td>
          <td class="amount text-right">
            <div><b>{{item.deliveredAmount|float:1}}</b> / {{item.plannedAmount|float:1}} m<sup>3</sup></div>
            <ngb-progressbar
              type="success"
              [value]="getProgressPercentage(item)"
              [showValue]="false">
            </ngb-progressbar>
          </td>
          <td class="remaining text-right">
            <b>{{item.remainingAmount|float:1}}</b> m<sup>3</sup>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #noDeliveries>
    <jbm-empty-view [emptyView]="true"></jbm-empty-view>
  </ng-template>
</ng-template>
